export default "__VITE_ASSET__DsR6TAqe__"